import * as z from "zod";

export const Currencies = z.enum(["eur", "gbp", "usd",]);

export const LoginSchema = z.object({
    email: z.string().email({
        message: "Invalid email",
    }),
    password: z.string().min(8, {
        message: "Minimum 8 characters required",
    }),
});

export const RegisterSchema = z.object({
    name: z.string().min(1, {
        message: "Name is required",
    }),
    email: z.string().email({
        message: "Email is required",
    }),
    password: z.string().min(8, {
        message: "Minimum 8 characters required",
    }).refine(password => (
        /[a-z]/.test(password) &&
        /[A-Z]/.test(password) &&
        /[\d\W]/.test(password)
    ), {
        message: "Password must contain at least 1 small letter, 1 capital letter, and 1 number or symbol",
    }),
    confirmPassword: z.string(),
    phone: z.string().min(10, {
        message: "Invalid phone number",
    }),
    city: z.string().min(1, {
        message: "City/Town is required",
    }),
    county: z.string().min(1, {
        message: "County is required",
    }),
    postcode: z.string()
        .trim()
        .min(1, { message: "Postcode is required" })
        .regex(/^[A-Z]{1,2}\d[A-Z0-9]?\s*\d[A-Z]{2}$/i, { message: "Invalid UK postcode format" }),
    registerAs: z.string().min(1, {
        message: "This is required.",
    }).refine(value => ["CUSTOMER", "DRIVER"].includes(value), {
        message: "Invalid Selection",
    }),
    currency: Currencies,
    termsAccepted: z.boolean().refine(value => value === true, {
        message: "Please accept the terms and conditions.",
    }),
    newsletterAccepted: z.boolean(),
}).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
});

export const ResetSchema = z.object({
    email: z.string().email({
        message: "Invalid email",
    })
});

export const NewPasswordSchema = z.object({
    password: z.string().min(8, {
        message: "Minimum 8 characters required",
    }).refine(password => (
        /[a-z]/.test(password) &&
        /[A-Z]/.test(password) &&
        /[\d\W]/.test(password)
    ), {
        message: "Password must contain at least 1 small letter, 1 capital letter, and 1 number or symbol",
    }),
    confirmPassword: z.string(),
}).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
});


export const ContactFormSchema = z.object({
    name: z.string().min(1, {
        message: "Name is required",
    }),
    email: z.string().email({
        message: "Email is required",
    }),
    phone: z.string().min(10, {
        message: "Invalid phone number",
    }),
    message: z.string().min(1, {
        message: "Message is required",
    }),
});